import React from 'react';
import style from '../css/Card_three.module.css';
import image1 from '../assets/images/image_3.png';

import supportImage from '../assets/images/image_4.png';

function Card_three() {
	return (
		<div className={style.container}>
			<h2 className={style.title}>
				Industry-leading technology with a <br /> personal touch
			</h2>

			<div className={style.section}>
				<div className={style.card}>
					<div className={style.left}>
						<h3>Employee travel freedom</h3>
						<p>
							Exporest’s corporate travel management platform lets employees
							book, update, or cancel trips on their own — easily and
							intuitively.
						</p>
					</div>

					<img src={image1} alt="Employee travel UI" className={style.img} />
				</div>
			</div>

			<div className={style.section}>
				<div className={style.card}>
					<img
						src={supportImage}
						alt="Support conversation UI"
						className={style.img}
					/>

					<div className={style.right}>
						<h3>Expert support when needed</h3>
						<p>
							Exporest’s support team is here 24/7 to handle traveler needs.
							Want a premium, high-touch service for VIPs? Our seasoned Reed &
							Mackay agents are available with ExporestPro.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Card_three;
